module.exports = __webpack_public_path__ + "static/img/图层20.cf8166f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/cardSolution/图层20.png
// module id = UygH
// module chunks = 0